import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  pure: false
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (isNaN(bytes) || bytes === 0) return '0 Byte';

    const sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const fileSize = parseFloat((bytes / Math.pow(1024, i)).toFixed(2)).toString().replace('.', ',');
    return `${fileSize} ${sizes[i]}`;
  }
}
